import { render } from "./list-header.vue?vue&type=template&id=1badc33c&ts=true"
import script from "./list-header.vue?vue&type=script&lang=ts"
export * from "./list-header.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__